<div class="copy-user">
  <form [formGroup]="userFormGroup" autocomplete="no-autofill">
    <div class="title-actions">
      <div class="txt-button dialog__close" (click)="closeDialog()">
        <mat-icon aria-hidden="false" aria-label="Close icon">close</mat-icon>{{ 'shared.close' | translate }}
      </div>
    </div>
    <mat-label class="copy-user__label">{{ 'admin.emailAddress' | translate | titlecase }}</mat-label>
    <mat-form-field appearance="outline">
      <input
        matInput
        placeholder="{{ 'admin.emailAddress' | translate | titlecase }}"
        type="email"
        formControlName="email"
        autocomplete="no-autofill"
        required
      />
    </mat-form-field>
    <div class="copy-user__checkbox">
      <mat-checkbox class="roleClass" formControlName="rolePermissions">{{ 'admin.copyRole' | translate }}</mat-checkbox>
      <mat-checkbox formControlName="profileSettings">{{ 'admin.copyProfile' | translate }}</mat-checkbox>
    </div>
    <button class="copy-user__applybtn" [disabled]="userFormGroup.invalid" (click)="copyUser()">
      {{ 'admin.apply' | translate }}
    </button>
  </form>
</div>
